export { default as EmbeddedAssetSwitch } from './EmbeddedAssetSwitch';
